import pushNotificationService from '../services/pushNotificationService';

const handleResponse = (result, fallbackMessage) => {
  if (!result?.success) {
    const error = new Error(result?.message || fallbackMessage);
    error.details = result;
    throw error;
  }
  return result;
};

export const sendPushNotification = async (payload) => {
  const result = await pushNotificationService.sendPushNotification(payload);
  return handleResponse(result, 'Push notification gönderilemedi').data;
};

export const sendPushNotificationToAll = async (payload) => {
  const result = await pushNotificationService.sendPushNotificationToAll(payload);
  return handleResponse(result, 'Tüm üyelere push notification gönderilemedi').data;
};

export const sendPushNotificationToMember = async (payload) => {
  const result = await pushNotificationService.sendPushNotificationToMember(payload);
  return handleResponse(result, 'Üyeye push notification gönderilemedi').data;
};

export const sendPushNotificationToMembers = async (payload) => {
  const result = await pushNotificationService.sendPushNotificationToMembers(payload);
  return handleResponse(result, 'Üyelere push notification gönderilemedi').data;
};

export const sendPushNotificationToGroup = async (payload) => {
  const result = await pushNotificationService.sendPushNotificationToGroup(payload);
  return handleResponse(result, 'Gruba push notification gönderilemedi').data;
};

export const sendPushNotificationToGroups = async (payload) => {
  const result = await pushNotificationService.sendPushNotificationToGroups(payload);
  return handleResponse(result, 'Gruplara push notification gönderilemedi').data;
};

export const sendPushNotificationToDevice = async (payload) => {
  const result = await pushNotificationService.sendPushNotificationToDevice(payload);
  return handleResponse(result, 'Device token\'a push notification gönderilemedi').data;
};

export const testDeviceToken = async (payload) => {
  const result = await pushNotificationService.testDeviceToken(payload);
  return handleResponse(result, 'Device token test edilemedi').data;
};

export const fetchPushNotificationRecords = async (params = {}) => {
  const result = await pushNotificationService.getPushNotificationRecords(params);
  const handled = handleResponse(result, 'Push notification kayıtları alınamadı');
  return {
    data: handled.data || [],
    meta: handled.metaData || {
      totalCount: handled.data?.length || 0,
      pageSize: params?.pageSize || 10,
      currentPage: params?.pageNumber || 1,
      totalPages: 1,
      hasNext: false,
      hasPrevious: false,
    },
  };
};

export const fetchPushNotificationRecordById = async (id) => {
  const result = await pushNotificationService.getPushNotificationRecordById(id);
  return handleResponse(result, 'Push notification kaydı alınamadı').data;
};

export default {
  sendPushNotification,
  sendPushNotificationToAll,
  sendPushNotificationToMember,
  sendPushNotificationToMembers,
  sendPushNotificationToGroup,
  sendPushNotificationToGroups,
  sendPushNotificationToDevice,
  testDeviceToken,
  fetchPushNotificationRecords,
  fetchPushNotificationRecordById,
};

